import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from "lodash";
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
import { SharedService } from 'src/app/Service/shared.service';
declare var $: any

@Component({
  selector: 'app-offres-emplois',
  templateUrl: './offres-emplois.component.html',
  styleUrls: ['./offres-emplois.component.scss']
})
export class OffresEmploisComponent implements OnInit {
  Etapes: any[];
  Types: any[];
  lenth: number;
  langue: any;

  constructor(private global: Global, private service: PublicationsService, private shared: SharedService, private route: ActivatedRoute, private router: Router) { }
  currentlang = '';
  currentUrl;
  outputLg;
  slick: any = null;
  dataOffres;
  Id;
  isclicked = false;
  selectedOffre;
  OffresGlobals = [];
  filter = {};
  description;
  descriptionFooter;
  canCandidate = false;
  isExterne = false;
  annonce = null;
  fiche = null;
  appreciation = null;
  resultats = null
  ecrite = null
  orale = null

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.outputLg = lg;
      this.currentlang = lg.url;
      this.currentUrl = this.router.url
      this.langue = lg;
      this.route.params.subscribe(params => {
        this.Id = params["Id"];
        if (this.Id) {
          this.isclicked = true;
          this.service.getEmploiById(lg.url, this.Id).subscribe(data => {
            this.isExterne = data["value"][0]["Annonce"] == "Externe";
            this.selectedOffre = data["value"][0];
            if (this.isExterne) {
              // this.annonce = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.replace(/_|-|\s/g, "").toLowerCase().includes("annonce"))[0];
              this.annonce = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("annonce"))[0];
              this.resultats = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("resultat"))[0]
              this.ecrite = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("ecrite") || a.FileName.toLowerCase().includes("écrite"))[0]
              this.orale = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("orale"))[0]
              this.fiche = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("fiche"))[0]
              this.appreciation = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("appreciation"))[0]
            } else {
              this.annonce = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("annonce"))[0];
              this.resultats = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("resultat"))[0]
              this.fiche = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("fiche"))[0]
              this.appreciation = this.selectedOffre.AttachmentFiles.filter(a => a.FileName.toLowerCase().includes("appreciation"))[0]
            }
            
            let delai = new Date(data['value'][0].DelaiDepot);
            //@ts-ignore
            delai.addHours(1);
            delai = new Date(delai.toLocaleDateString("en"))
            const currentDate = new Date(new Date().toLocaleDateString("en"));
            if (currentDate > delai || data['value'][0]["Annonce"] == "Externe") {
              this.canCandidate = false;
            } else {
              this.canCandidate = true;
            }
          })
        } else {
          this.isclicked = false;
          this.dataOffres = [];
          this.service.getEmplois(lg.url).subscribe(data => {
            this.Types = _.uniq(_.flatMap(data["value"], ({ Annonce }) => Annonce));
            this.Etapes = _.uniq(_.flatMap(data["value"], ({ EtapeActuelle }) => EtapeActuelle));
            this.OffresGlobals = data["value"];
            this.lenth = this.OffresGlobals.length;
            this.dataOffres = this.OffresGlobals;
            if (this.slick != null) {
              this.reload();
            } else {
              setTimeout(() => this.sliderAppel(), 100);
            }
          })
        }
      })
      this.shared.getBlocDescriptionByCode(lg.url, "offresEmplois").subscribe(data => {
        this.description = data["value"][0];
      })
    })
  }

  converteDate(d) {
    return this.global.formattedDate(d);
  }

  sliderAppel() {
    this.slick = $('#offres').dataTable({
      data: this.dataOffres,
      columns: [
        {
          data: 'DatePublication',
          render: (data, type, row) => {
            return this.converteDate(data);
          }
        },
        { data: 'Title' },
        { data: "EtapeActuelle" },
        { data: 'Annonce' }
      ],
      columnDefs: [{ 'targets': 0, type: 'date-euro' }],
      "language": {
        "paginate": {
          "previous": '«',
          "next": '»'
        }
      },
      "searching": false,
      "info": false,
      "lengthChange": false,
      "order": []
    });
    var b = this.router;
    $('#offres tbody').on('click', 'tr', function (e) {
      var data = $('#offres').DataTable().row(this).data();
      b.navigate(["publications/offres-emplois/" + data.ID]);
    });
  }
  reload() {
    $('#offres').DataTable().clear();
    $('#offres').DataTable().rows.add(this.dataOffres);
    $('#offres').DataTable().columns.adjust().draw();
  }
  lancerFilter(filter) {
    this.filter = filter;
    this.dataOffres = [];
    this.dataOffres = this.transform(this.OffresGlobals, filter);
    this.lenth = this.dataOffres.length;
    if (this.slick != null) {
      this.reload();
    } else {
      setTimeout(() => this.sliderAppel(), 100);
    }
  }
  transform(objet, filters): any[] {
    return objet.filter(element => {
      let a = true;
      filters.ObjetAppelOffre ? a = a && (element['Title'] as string).toUpperCase().includes(filters.ObjetAppelOffre.toUpperCase()) : null;
      filters.Type && filters.Type != '' ? a = a && filters.Type == element['Annonce'] : null;
      filters.Etape && filters.Etape != '' ? a = a && filters.Etape == element['EtapeActuelle'] : null;
      return a;
    });
  }
}

@Pipe({ name: 'emploiFilter' })
export class EmploiFilterPipe implements PipeTransform {
  transform(objet: [], filters: any): any[] {
    return objet.filter(element => {
      let a = true;
      filters.ObjetAppelOffre ? a = a && (element['ObjetAppelOffre'] as string).includes(filters.ObjetAppelOffre.toUpperCase()) : null;
      filters.Region && filters.Region != '' ? a = a && filters.Region == element['RegionId'] : null;
      filters.Domain && filters.Domain != '' ? a = a && filters.Domain == element['Domaine'] : null;
      filters.DatePlis && filters.DatePlis != '' ? a = a && new Date(filters.DatePlis) == new Date(element['Date_x0020_limite_x0020_de_x00200']) : null;
      return a;
    });
  }
}